import { render, staticRenderFns } from "./IpRestriction.vue?vue&type=template&id=1ce35c22&"
import script from "./IpRestriction.vue?vue&type=script&lang=js&"
export * from "./IpRestriction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports